document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".custom-header");

  // Header Scroll Effect
  window.addEventListener("scroll", function () {

    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

  });

  // Ticker Slider
  jQuery('.ticker-slider').bxSlider({
    ticker: true,
    speed: 30000,
    tickerHover: true,

    controls: false,
    pager: false,

    slideWidth: 300,

    minSlides: 1,
    maxSlides: 20,
    moveSlides: 1,

    useCSS: true
  });

  // Init Function
  initTicker();

});